import { render, staticRenderFns } from "./DisplayServiceClient.vue?vue&type=template&id=8db46ad0&scoped=true"
import script from "./DisplayServiceClient.vue?vue&type=script&lang=js"
export * from "./DisplayServiceClient.vue?vue&type=script&lang=js"
import style0 from "./DisplayServiceClient.vue?vue&type=style&index=0&id=8db46ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db46ad0",
  null
  
)

export default component.exports